import { ReactElement } from 'react';

/** Plain circle formatting around the LinkedIn/YouTube external links. Should be replaced
 * with something more accessible & re-usable */
const CircleButton = ({ children }: { children: ReactElement }) => {
  return (
    <div className='w-[32px] h-[32px] bg-[#1275B1] rounded-full flex items-center justify-center'>
      {children}
    </div>
  );
};

export default CircleButton;
